const fonts = {
    '$font-family-sans-serif': 'Montserrat, sans-serif',
    '$font-family-sans-serif-regular': 'Montserrat, sans-serif',

};

export default fonts;
